import {Locale} from '@aboutyou/config';
import {useCookie} from '@aboutyou/storage';

// WARNING - This cookie name has to match the name in varnish and it should have value with format `subdomain|Locale` eg: `m-en|en_DE`
// https://gitlab.com/aboutyou/retail/aysa/aysa-ansible-playbook/-/blob/master/group_templates/aym_x_varnish/varnish/local.vcl#L240-246
const PREFERRED_LANGUAGE_LOCALE_SUBDOMAIN_COOKIE_NAME = 'aysa-locale-subdomain';

const transformCookieRawValue = (rawValue: string | undefined) =>
  rawValue || '';
export const usePreferredLocale = () => {
  const [cookieValue, setCookieValue] = useCookie<string | undefined>({
    cookieName: PREFERRED_LANGUAGE_LOCALE_SUBDOMAIN_COOKIE_NAME,
    defaultValue: undefined,
    transformRawValue: transformCookieRawValue,
  });
  const preferredLocale = getLocaleFromCookie(cookieValue);

  const setPreferredLocale = ({locale, url}: {locale: Locale; url: string}) => {
    const targetSubdomain = getSubdomainFromUrl(url);

    setCookieValue(
      // the value should be in `targetSubDomain|targetLocale` format to be compatible with Varnish
      `${targetSubdomain}|${locale}`,
    );
  };

  return {
    preferredLocale,
    setPreferredLocale,
  };
};

const getLocaleFromCookie = (
  cookieValue: string | undefined,
): Locale | null => {
  if (!cookieValue) {
    return null;
  }

  const [_, locale] = cookieValue.split('|');
  if (!locale) {
    return null;
  }

  return locale as Locale;
};

const getSubdomainFromUrl = (url: string) => {
  const hostname = new URL(url).hostname;
  const [subdomain] = hostname.split('.');
  return subdomain!;
};
